import React from 'react';
const CTA_LINK = 'https://wa.me/40756617959';
interface ButtonProps {
  variant?: 'primary' | 'outline';
  className?: string;
  children: React.ReactNode;
}
export const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  className = ''
}) => {
  const baseStyle = 'inline-flex items-center justify-center px-8 py-4 font-display font-semibold tracking-wide transition-all duration-300 text-sm uppercase';
  const variants = {
    primary: 'bg-gold text-navy-dark hover:bg-white hover:text-navy-dark',
    outline: 'border border-gold text-gold hover:bg-gold hover:text-navy-dark'
  };
  return <a href={CTA_LINK} target="_blank" rel="noopener noreferrer" className={`${baseStyle} ${variants[variant]} ${className}`} data-id="element-236">
      {children}
    </a>;
};
export const NeuralBackground = () => <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-[0.15]" data-id="element-237">
    <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-238">
      <defs data-id="element-239">
        <pattern id="neural" x="0" y="0" width="120" height="120" patternUnits="userSpaceOnUse" data-id="element-240">
          <circle cx="30" cy="30" r="1.5" fill="#C9A84C" data-id="element-241" />
          <circle cx="90" cy="45" r="2" fill="#C9A84C" data-id="element-242" />
          <circle cx="45" cy="90" r="1.5" fill="#C9A84C" data-id="element-243" />
          <circle cx="105" cy="105" r="1" fill="#C9A84C" data-id="element-244" />
          <path d="M30 30 L90 45 L45 90 Z" fill="none" stroke="#C9A84C" strokeWidth="0.5" data-id="element-245" />
          <path d="M90 45 L105 105 L45 90" fill="none" stroke="#C9A84C" strokeWidth="0.5" data-id="element-246" />
          <path d="M-10 60 L30 30" fill="none" stroke="#C9A84C" strokeWidth="0.5" data-id="element-247" />
          <path d="M130 30 L90 45" fill="none" stroke="#C9A84C" strokeWidth="0.5" data-id="element-248" />
        </pattern>
      </defs>
      <rect x="0" y="0" width="100%" height="100%" fill="url(#neural)" data-id="element-249" />
    </svg>
  </div>;
export const SectionDivider = () => <div className="w-full h-px bg-gradient-to-r from-transparent via-gold/30 to-transparent" data-id="element-250" />;